<template>
  <span>{{ formattedDate }}</span>
</template>

<script>
import moment from 'moment'

export default {
  props: {
    date: { type: String, default: new Date().toUTCString() },
    convertUtc: { type: Boolean, default: true },
  },
  data() {
    return {}
  },
  computed: {
    formattedDate() {
      let date = moment(this.date)
      if (this.convertUtc) {
        date = date.utc()
      }
      return date.format('MMM D HH:mm')
    },
  },
}
</script>
